function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { node, string } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import SovosTypography from '../sovos-typography';
import SovosFixedWidthText from '../sovos-fixed-width-text';
const StyledHeader = styled('header')(_ref => {
  let {
    theme: {
      palette,
      spacing
    }
  } = _ref;
  return {
    alignItems: 'center',
    borderBottom: "1px solid ".concat(palette.divider),
    boxSizing: 'border-box',
    display: 'flex',
    flexBasis: spacing(6),
    flexGrow: 0,
    flexShrink: 0,
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    padding: "0 ".concat(spacing(3)),
    '& .sovosDrawerHeader__title': {
      color: palette.text.primary,
      flex: '1 1 auto',
      lineHeight: 1.2,
      margin: 0,
      maxWidth: '100%',
      padding: "".concat(spacing(), " 0")
    },
    '& .sovosDrawerHeader__content': {
      flex: '1 1 auto',
      padding: "".concat(spacing(), " 0")
    }
  };
});

/**
 * **Note** Must be a child `SovosDrawer`
 */
const SovosDrawerHeader = _ref2 => {
  let {
    children,
    className,
    title,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledHeader, _extends({
    className: clsx('sovosDrawerHeader', className)
  }, rest), /*#__PURE__*/React.createElement(SovosTypography, {
    className: "sovosDrawerHeader__title",
    component: "h2",
    variant: "h4"
  }, typeof title === 'string' ? /*#__PURE__*/React.createElement(SovosFixedWidthText, {
    text: title
  }) : title), /*#__PURE__*/React.createElement("div", {
    className: "sovosDrawerHeader__content"
  }, children));
};
SovosDrawerHeader.propTypes = {
  /**
   * The content of the drawer header
   */
  children: node,
  /**
   * The content of the drawer header
   */
  className: string,
  /**
   * The title content
   */
  title: node.isRequired
};
export default SovosDrawerHeader;